import { NotesHeader } from "./Notes.Header";
import { NotesMain, NotesMainProps } from "./Notes.Main";

type NotesProps = NotesMainProps;
export const Notes = ({ ...props }: NotesProps) => {
  return (
    <div className="w-full space-y-4">
      <NotesHeader />
      <NotesMain {...props} />
    </div>
  );
};
